import { useEffect, useMemo, useState } from "react"
import { BookingForm } from "../common/BookingForm"
import { CalendarWithTime } from "../common/CalendarWithTime"
import { toast } from "sonner"
import { AddPhoneMessage } from "./phone/AddPhoneMessage"
import auth from "@/shared/api/auth"
import booking from "@/shared/api/booking"
import { format } from "date-fns"


export const ProfileScheduler = () => {
    const [selectedDay, setSelectedDay] = useState(() => {
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        return now
    })
    const [time, setTime] = useState(null)
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [comment, setComment] = useState("")
    const [bookingByDay, setBookingByDay] = useState(new Map());
    const [mode, setMode] = useState()
    const [selectedBookingId, setSelectedBookingId] = useState(null)

    const [user, setUser] = useState(null);

    const fetchUser = async () => {
        try {
            const res = await auth.profile();
            setUser(res.user);
            setName(res.user.name ?? "");
            setPhone((res.user.phone ?? "")?.slice(1));
            if (res.user.phone && res.user.phoneVerified) {
                setMode("phone");
            }
        } catch (err) {
            console.error(err.message);
        }
    };

    function groupByDateMap(data) {
        const map = new Map()

        for (const item of data) {
            const date = item.date
            if (!map.has(date)) {
                map.set(date, [])
            }
            map.get(date).push(item)
        }

        return map
    }

    const handleSelectPeriod = async () => {
        try {
            const res = await booking.getUserBooking();
            console.log(res)
            setBookingByDay(groupByDateMap(res));
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        fetchUser();
        handleSelectPeriod();
    }, [])

    const formatLocalDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }
    const dateKey = useMemo(() => (selectedDay ? formatLocalDate(selectedDay) : null), [selectedDay])

    const onSubmit = async (e) => {
        e.preventDefault()

        // rawPhone уже содержит чистые цифры из состояния
        const rawPhone = phone;

        if (!selectedDay || !time || !name || !rawPhone) {
            toast.error("Заполните все обязательные поля")
            return
        }

        // Валидация номера телефона (например, 375 и 9 цифр после)
        const phoneRegex = /^375\d{9}$/;
        if (!phoneRegex.test(rawPhone)) {
            toast.error("Пожалуйста, введите корректный номер телефона (например, +375 (XX) XXX-XX-XX)");
            return;
        }

        try {
            const payload = { date: dateKey, time, name, phone: '+' + rawPhone, comment }
            const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/api/booking", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })

            const data = await res.json()
            if (!res.ok) throw new Error(data.message || "Ошибка бронирования")

            toast.success("Запись успешно создана. Мы свяжемся с вами по телефону.")
            setBookingByDay(prev => {
                if (prev?.get(format(selectedDay, "yyyy-MM-dd"))?.length) prev.get(format(selectedDay, "yyyy-MM-dd")).push({ _id: data.booking._id, time, name, phone: '+' + rawPhone, comment })
                else prev.set(format(selectedDay, "yyyy-MM-dd"), [{ _id: data.booking._id, time, name, phone: '+' + rawPhone, comment }])
                return prev
            });
            setSelectedBookingId(data.booking._id)

            setTime(null)
            setName("")
            setPhone("")
            setComment("")
        } catch (err) {
            toast.error(err.message)
        }
    }

    const handleMarkedTimeSelected = (data) => {
        if (data !== null) {
            setMode("phoneEdit")
            setPhone((data.phone ?? "")?.slice(1))
            setName(data.name)
            setComment(data.comment)
            setSelectedBookingId(data._id)
        } else {
            setMode("phone")
            const userPhone = user?.phone ?? "";
            setPhone(userPhone?.slice(1))
            setName(user?.name ?? "")
            setComment("")
            setSelectedBookingId(null)
        }
    }

    return (
        <div className="sm:bg-card bg-none sm:rounded-lg rounded-none sm:border border-none sm:p-4 px-0">
            <AddPhoneMessage phone={user?.phone} verified={user?.phoneVerified} onPhoneVerified={setMode} />
            <h2 className="font-serif text-3xl text-olive-950">Запись на встречу</h2>
            <p className="mt-2 text-olive-900/70 text-sm">Выберите удобные дату и время.</p>
            <div className="flex flex-row flex-wrap gap-4">

                <CalendarWithTime
                    dateKey={dateKey}
                    dateValue={selectedDay}
                    onDateChange={setSelectedDay}
                    timeValue={time}
                    onTimeChange={setTime}
                    markedLabel="Вы"
                    markedDatesMap={bookingByDay}
                    markedTimesMap={bookingByDay.get(format(selectedDay, "yyyy-MM-dd"))}
                    onMarkedTimeSelected={handleMarkedTimeSelected}
                    hideMarkedLabel
                />

                <BookingForm
                    dateKey={dateKey}
                    mode={mode}
                    onSubmit={onSubmit}
                    date={dateKey}
                    time={time}
                    name={name}
                    phone={phone}
                    comment={comment}
                    setName={setName}
                    setPhone={setPhone}
                    setComment={setComment}
                    id={selectedBookingId}
                    handleBookingChanged={setBookingByDay}
                    disabledTime={bookingByDay.get(format(selectedDay, "yyyy-MM-dd"))?.map(el => el.time)}

                />
            </div>
        </div>
    )
}